export default "__VITE_ASSET__BENsji18__"